import React, { useState, useEffect } from "react";
import { Button, Modal } from "react-bootstrap";
import { NavLink } from "react-router-dom";
// import "./support.css";
import { useDispatch } from "react-redux";
import { useRef } from "react";
import api from "../../../../seller-apis/api";
import { Actions } from "../../../../Actions/Actions";
function Message({ type, content, time, from, vendorId, participantId }) {
  const formatedDate = (time) => {
    const date = new Date(time);

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based, so we add 1.
    const year = date.getFullYear();

    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");

    const ampm = hours >= 12 ? "PM" : "AM";
    hours = String(hours % 12 || 12).padStart(2, "0");

    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds} ${ampm}`;
  };

  return (
    <>
      <div
        className={`message-box dis-flex justify-content-start ${
          vendorId == participantId ? "flex-row-reverse" : ""
        }`}
      >
        <div className="customer-image">
          <img
            src={`/leads-icon/user-icon${
              vendorId == participantId ? "-dark" : ""
            }.png`}
          />
          {from}
        </div>
        <div className={`message ${type}`}>
          <span className="message-content">
            {content}
            <br />
            <div className="chat-time text-right">{formatedDate(time)}</div>
          </span>
        </div>
      </div>
    </>
  );
}
const LeadsChatModal = ({ show, handleClose, channelId, selectedLead }) => {
  const [messages, setmessages] = useState([]);
  const [vendorId, setVendorId] = useState("");
  const [msgText, setMsgText] = useState(null);
  const [error, setError] = useState(false);
  const [channel, setChannel] = useState([]);
  const dispatch = useDispatch();
  const myDivRef = useRef(null);

  const scrollToBottom = () => {
    myDivRef.current.scrollTop = myDivRef.current.scrollHeight;
  };
  useEffect(() => {
    // if(!channelId)
    // {

    let param = {
      lead: selectedLead?._id,
    };

    api.leadChat.createChannel(param).then((res) => {
      // console.log(res.data.record)
      let param1 = {
        channelId: res.data.record._id,
      };
      api.leadChat.readMessage(param1).then(() => {
        api.leadChat.getUnreadCount().then((res)=>{
          // setChatCount(res?.data?.customerCount)
          Actions.leadChatCount(dispatch,res?.data?.customerCount);
            })
      });
      setChannel(res.data.record);
      getMessage(res.data.record._id);
    });
    // }
    // else{
    //   console.log("hgfjhgfj",channelId)
    //   getMessage(channelId);
    // }
    localStorage.getItem("userId") &&
      setVendorId(localStorage.getItem("userId"));
  }, [selectedLead?._id]);

  // const updateReadMsg=()=>{
  //   let param = {
  //     "_id": ticket._id,"adminMsgInfo.vendorViewed" : true
  //   };
  //   api.supportTicket
  //     .updateReadMessage(param)
  //     .then((res) => {
  //       getSupportMsgNotificationCount();
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // }

  const getMessage = (channelId = channel._id) => {
    let filter = {
      filter: {
        channelId: channelId,
      },
      offset: 0,
      size: 10,
    };
    api.leadChat
      .mesasageList(filter)
      .then((res) => {
        // console.log(res)
        setmessages(res.data.records);
        scrollToBottom();
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const saveMessage = () => {
    let param = {
      channelId: channel._id,
      lead: channel.lead,
      msg: msgText,
    };
    api.leadChat
      .saveMessage(param)
      .then((messages) => {
        console.log(messages);
        setMsgText("");
        getMessage();
        setError(false);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const closeChat = () => {
    setError(false);
    setMsgText("");
    handleClose();
  };

  return (
    <Modal
      contentLabel="Large Modal"
      className="large-modal ticket-modal"
      style={{ width: 400 }}
      centered
      show={show}
    >
      <div class="header-pop mx-3 mb-1">
        <div class="header-title">
          {channelId ? (
            <img
              src={`/leads-icon/arrow-back.png`}
              style={{ width: 20 }}
              onClick={() => closeChat()}
            />
          ) : (
            "Message"
          )}
        </div>
        <a class="close-pop" onClick={() => closeChat()}>
          ×
        </a>
      </div>
      <Modal.Body>
        <div className="customer-details">
          <div className="dis-flex">
            <div className="title">Customer Name : </div>
            <div className="value">{selectedLead?.name}</div>
          </div>
          <div className="dis-flex">
            <div className="title">Phone Number : </div>
            <div className="value">
              {selectedLead?.phone || selectedLead?.mobile}
            </div>
          </div>
          <div className="dis-flex">
            <div className="title">Email ID : </div>
            <div className="value">{selectedLead?.email}</div>
          </div>
          <div className="dis-flex">
            <div className="title">Product : </div>
            <div className="value">
              {selectedLead?.product.productName || selectedLead?.product.name}
            </div>
          </div>
        </div>
        <div className="chat-container">
          <div className="chat" style={{ height: "42vh" }} ref={myDivRef}>
            {messages.map((message, index) => (
              <Message
                key={index}
                type={vendorId == message.participant.id ? "vendor" : "buyer"}
                vendorId={vendorId}
                from={message.participant.id != vendorId ? `Buyer` : "You"}
                content={message.msg}
                participantId={message.participant.id}
                time={message.createdAt}
              />
            ))}
          </div>
          <div className="input-box relative suppor-msg-input">
            <input
              type="text"
              value={msgText}
              onChange={(e) => setMsgText(e.target.value)}
              placeholder="Type a message..."
            />

            {/* <img
              src="/attachment.png"
              alt="send"
              style={{
                position: "absolute",
                right: "12%",
                transform: "rotate(226deg)",
              }} 
            /> */}
            <div
              className="dis-flex apply-btn px-2 fs-14"
              onClick={() => {
                msgText ? saveMessage() : setError(true);
              }}
              style={{ padding: "10px 20px !important" }}
            >
              Send <img src="/send.png" alt="send" style={{ width: "32%" }} />
            </div>
          </div>
          <div class="error">
            {error && msgText == "" ? "Please add a message" : ""}
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default LeadsChatModal;